"use client";
import { cn } from "@/lib/utils";
import { House, Play } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

const SupportBar = () => {
  const pathname = usePathname();
  return (
    <footer className="h-14 border w-full relative">
      <div className="border  p-2 px-8 rounded-full flex gap-12 absolute left-1/2 -translate-x-1/2 bottom-4 backdrop-blur-[4px]">
        <Link href={"/faq"}>
          <div className="flex flex-col gap-1 items-center">
            <House className={cn("h-7 w-7", pathname.includes("faq") && 'text-gr')} />
            <span className="text-xs">Faq</span>
          </div>
        </Link>
        <Link href={"/support"}>
          <div className="flex flex-col gap-1 items-center">
            <Play  className={cn("h-7 w-7", pathname.includes("support") && 'text-gr')} />
            <span className="text-xs">Support</span>
          </div>
        </Link>
      </div>
    </footer>
  );
};

export default SupportBar;
